import React from 'react';
import s from '../../Carousel.scss';

const IconLeft = () => (
  <svg viewBox="0 0 100 100">
    <path
      d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z"
      className={s.arrow}
    />
  </svg>
);

IconLeft.displayName = 'IconLeft';

export default IconLeft;
